import * as React from 'react';
import ActionButton from 'components/buttons/action-button/ActionButton';
import { __t, applyTranslations } from 'utils/language';

import './subcampaign-offer-footer.scss';

applyTranslations(require('./subcampaign-offer-footer.i18n.json'));

const SubcampaignOfferFooter = (): JSX.Element => (
  <div className="subcampaign-offer-footer">
    <div className="subcampaign-offer-footer__action">
      <ActionButton
        width="maximum"
        color="primary"
        link="/content-creator/profiles"
        newTab
      >
        {__t('subcampaign_offer_footer.find_content_creators')}
      </ActionButton>
    </div>
  </div>
);

export default SubcampaignOfferFooter;
